import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { Router, Resolve } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { AngularFireAuth } from 'angularfire2/auth';
import { User, FirebaseAuth } from '@firebase/auth-types';

import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class AuthService implements OnDestroy {
  private ngUnsubscribe = new Subject();
  public user: User;
  public idToken: any;

  constructor(
    public afAuth: AngularFireAuth,
    private router: Router) {
      this.afAuth.authState
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(user => {
          this.user = user;
          if(user) {
            this.user.getIdToken().then(token =>{
              this.idToken = token;
            })
            this.router.navigate(['app']);
          }
          else {
            this.router.navigate(['login']);
          }
        });
    }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  logout() {
    this.afAuth.auth.signOut();
  }

  public isLoggedIn(): boolean {
    if (this.user) {
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts